var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-block"},[_c('div',{staticClass:"form-content"},[_vm._t("default")],2),_c('div',{staticClass:"calculation"},[_c('CalculationResult',{attrs:{"number":_vm.formatNumber,"unit":_vm.unit,"sign":_vm.sign}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }